import axios from 'axios'

if (!process.env.FUNCTIONS_API) {
  console.error('NO API SPECIFIED IN .ENV FILE')
}

// Instance
const xhr = axios.create({
  baseURL: process.env.FUNCTIONS_API,
  // headers: { 'X-Requested-With': 'XMLHttpRequest' },
  // withCredentials: true, // (for JWT)
})

// Middleware
xhr.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (!error.response) return Promise.reject(error.message)
    const { status, data } = error.response
    return Promise.reject({ status, message: data })
  }
)

export default xhr
